import { useHistory } from 'react-router-dom';
import { sendRequest } from '../requests/useRequest';
import { useSweetAlert } from '../sweetAlerts/useSweetAlert';
import { validarSesion } from '../tokens/useToken';
import { useForm } from '../forms/useForm';
import moment from 'moment';
import 'moment/locale/es';
import { useEffect, useState } from 'react';

import * as XLSX from 'xlsx';

export const usePendingExternaLabs = () => {

    const history = useHistory();

    const [loading, setLoading] = useState(false);
    const [createSweet] = useSweetAlert();
    const [reportPendingExams, setReportPendingExams] = useState([]);

    const [externalLaboratory, setExternalLaboratory] = useState([]);

    useEffect(() => {
        getExternalLaboratories();
    }, [])

    const [formValues, handleInputChange, reset, handleUpdateValues, handleSelectValues, handlePickerValues] = useForm({
        mDateRange1: "",
        mDateRange2: "",
        mSelectLaboratoryExt: null,
        release_mode: 0

    });


    const {
        mDateRange1, mDateRange2, mSelectLaboratoryExt, release_mode

    } = formValues;



    //#region ExternalLaboratories

    const getExternalLaboratories = async () => {
        const _list = await handleRequest("GET", "ExternalLaboratories/List", "External Laboratories");

        if (_list !== null && _list.length > 0) {
            let _list_External_Laboratories = [];


            _list.forEach(_external_Laboratories => {
                _list_External_Laboratories.push({
                    label: _external_Laboratories.name,
                    value: _external_Laboratories.id_external_laboratory,
                });
            });


            // console.log("🚀 ~ getSections ~ _list_sections:", _list_sections)
            setExternalLaboratory(_list_External_Laboratories);
        } else {
            setExternalLaboratory([]);
        }
    }

    //#endregion Sections


    //#region Filter Reports Pending 

    const getPedingWorkLabsExternal = (e, search = true) => {
        if (e) e.preventDefault();

        if (search) {
            let query = "";
            let _mfrom = (mDateRange1) ? moment(mDateRange1).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD");
            let _mto = (mDateRange2) ? moment(mDateRange2).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD");
            let idExternal_laboratory = mSelectLaboratoryExt ? mSelectLaboratoryExt.value : '';
            let releaseM = release_mode?.value ?? release_mode ?? 0;

            console.log('Filtro laboratorio:', idExternal_laboratory);

            if (_mfrom !== "") {
                query += `start=${_mfrom}`;
            }

            if (_mto !== "") {
                query += `&end=${_mto}`;
            }

            if (idExternal_laboratory !== "") {
                query += `&id_external_laboratory=${idExternal_laboratory}`;
            }

            query += `&release_mode=${releaseM}`;

            setLoading(true);

            getReportPendingExamsLabsExt(true, query);
        }
    }

    const getReportPendingExamsLabsExt = async (_search = false, _filter) => {
        setLoading(true);
        let _listTmp = {};

        if (_search === false) {
            _listTmp = await handleRequest("GET", `Reports/ReportExtenalLabPendingExams?`, 'Report');
        } else {
            _listTmp = await handleRequest("GET", `Reports/ReportExtenalLabPendingExams?${_filter}`, 'Report');
        }

        if (_listTmp && Array.isArray(_listTmp)) {
            setReportPendingExams(_listTmp);
            setPedingWork(_listTmp);
        } else {
            setReportPendingExams([]);
        }

        setLoading(false);
    };

    useEffect(() => {
        getPedingWorkLabsExternal(null, true);
    }, []);


    const handleClean = () => {

        handleUpdateValues({
            mDateRange1: "",
            mDateRange2: "",
            mSelectLaboratoryExt: 0,
            release_mode: 0
        });
        setReportPendingExams([]);

        // getReportPendingExams(false)
    }


    // region Clear Laboratory
    const handleCleanLaboratory = () => {
        handleUpdateValues(prev => ({
            ...prev,
            mSelectLaboratoryExt: null,
        }));

        let query = "";
        let _mfrom = (mDateRange1) ? moment(mDateRange1).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD");
        let _mto = (mDateRange2) ? moment(mDateRange2).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD");
        let releaseM = release_mode?.value ?? release_mode ?? 0;

        query += `start=${_mfrom}&end=${_mto}&release_mode=${releaseM}`;

        setLoading(true);
        getReportPendingExamsLabsExt(true, query);
    };





    //*



    //#endregion

    //#region GLOBAL REQUEST
    const handleRequest = async (method, methodUrl, nameMethod, body = null) => {
        let requestOptions = {
            method: method
        };

        if (body !== null) {
            requestOptions = {
                ...requestOptions,
                body: JSON.stringify(body)
            };
        }

        const response = await sendRequest(requestOptions, methodUrl);

        if (response.code === 200) {
            return response.data;
        }
        else if (response.code === 401) {
            validarSesion(history, response.code, handleRequest);
        }
        else if (response.code === 500) {
            createSweet("error", "error", nameMethod, "Ocurrio un error en el servidor");
        }
        else {
            createSweet("warning", "warning", nameMethod, response.data.msg);
        }

        return null;
    }

    // #endregion



    useEffect(() => {
        if (mSelectLaboratoryExt) {
            getPedingWorkLabsExternal();
        }
    }, [mSelectLaboratoryExt]);

    // #region Indicators

    const nameLaboratory = () => {
        return mSelectLaboratoryExt?.label || "Todos los Laboratorios";
    };

    const totalNims = () => {
        const uniqueNims = new Set();

        reportPendingExams.forEach(item => {
            if (item?.nim) {
                uniqueNims.add(item.nim);
            }
        });

        return uniqueNims.size;
    };

    const totalExam = () => {
        return reportPendingExams.length;
    };


    // #endregion


    // #region Search Exams
    const [pedingWork, setPedingWork] = useState([]);

    const handleSearchPedingWork = (e) => {
        let busqueda = e.target.value.toUpperCase();
        let newMethod = [];

        pedingWork.forEach(element => {
            const nim = element.nim?.toString().toUpperCase() || "";
            const labName = element.laboratory?.toUpperCase() || "";

            const fullName = `${element.name || ""} ${element.paternal_surname || ""} ${element.maternal_surname || ""}`.toUpperCase();

            if (
                fullName.includes(busqueda) ||
                nim.includes(busqueda) ||
                labName.includes(busqueda)
            ) {
                element.visibleTable = true;
                newMethod.push(element);
            }
        });

        setReportPendingExams(newMethod);
    };


    // #endregion

    // #region Excel report extarnal laboratories
    const exportExcel = () => {
        if (!reportPendingExams || reportPendingExams.length === 0) {
            createSweet("error", "error", "", "No hay datos para exportar");
            return;
        }

        const groupedData = {};

        reportPendingExams.forEach(item => {
            const key = `${item.laboratory}_${item.nim}_${item.name}_${item.paternal_surname}_${item.maternal_surname}_${item.study_delivery}`;

            if (!groupedData[key]) {
                groupedData[key] = {
                    'Laboratorio': item.laboratory,
                    'NIM': item.nim,
                    'Nombre del Paciente': `${item.name} ${item.paternal_surname} ${item.maternal_surname}`,
                    'Fecha promesa': item.study_delivery,
                    'Exámenes': [item.exam],
                    'Costo': [item.cost],
                    'Precio': [item.price],
                    'Estatus': [item.released ? "Liberado" : "Pendiente de liberar"]
                };
            } else {
                groupedData[key]['Exámenes'].push(item.exam);
                groupedData[key]['Costo'].push(item.cost);
                groupedData[key]['Precio'].push(item.price);
                groupedData[key]['Estatus'].push(item.released ? "Liberado" : "Pendiente de liberar");
            }
        });

        const aoa = [
            ['Laboratorio', 'NIM', 'Nombre del Paciente', 'Fecha promesa', 'Exámenes', 'Costo', 'Precio', 'Estatus']
        ];

        const merges = [];
        let currentRow = 1;

        Object.values(groupedData).forEach(item => {
            const exams = item['Exámenes'];
            const costos = item['Costo'];
            const prices = item['Precio'];
            const estatus = item['Estatus'];

            exams.forEach((exam, index) => {
                aoa.push([
                    index === 0 ? item['Laboratorio'] : '',
                    index === 0 ? item['NIM'] : '',
                    index === 0 ? item['Nombre del Paciente'] : '',
                    index === 0 ? item['Fecha promesa'] : '',
                    exam,
                    costos[index],
                    prices[index],
                    estatus[index]
                ]);
            });

            if (exams.length > 1) {
                merges.push(
                    { s: { r: currentRow, c: 0 }, e: { r: currentRow + exams.length - 1, c: 0 } },
                    { s: { r: currentRow, c: 1 }, e: { r: currentRow + exams.length - 1, c: 1 } },
                    { s: { r: currentRow, c: 2 }, e: { r: currentRow + exams.length - 1, c: 2 } },
                    { s: { r: currentRow, c: 3 }, e: { r: currentRow + exams.length - 1, c: 3 } }


                );
            }

            currentRow += exams.length;
        });

        console.log("🚀 ~ exportExcel ~ aoa:", aoa)


        const worksheet = XLSX.utils.aoa_to_sheet(aoa);
        worksheet['!merges'] = merges;

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Pendientes');

        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const dataBlob = new Blob([excelBuffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });

        const fileName = 'Pendientes de Laboratorio Referenciado.xlsx';

        const url = window.URL.createObjectURL(dataBlob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    };

    //#endregion

    return {

        handleClean, handleInputChange, externalLaboratory, handleCleanLaboratory,
        // filter
        mDateRange1, mDateRange2, loading, handleSelectValues, reportPendingExams, mSelectLaboratoryExt,
        getPedingWorkLabsExternal, release_mode,

        // Indicators
        nameLaboratory, totalNims, totalExam,

        // search
        handleSearchPedingWork,

        // excel

        exportExcel



    }
}
